module.exports = __webpack_public_path__ + "static/media/020.ee6e9d37.jpg";